import { getProjectsByUserId } from '@common/modules/projects/projects'
import type { Project } from '@common/modules/projects/types/project.types'

let inFlight: Promise<Project[]> | null = null

export function resetProjectsFetchDedupedInFlight(): void {
  inFlight = null
}

/**
 * Deduplicates concurrent calls to the session-scoped GetProjectsByUserId fetch while the list
 * is being loaded (e.g. Strict Mode double effects + init + page effects).
 */
export function getProjectsByUserIdDeduped(): Promise<Project[]> {
  if (!inFlight) {
    inFlight = getProjectsByUserId().finally(() => {
      inFlight = null
    })
  }
  return inFlight
}
